import React from "react";

import { Checkbox, CheckboxProps } from "antd";

export interface CheckboxSegmentedProps extends CheckboxProps {
  label: string | React.ReactNode;
  className?: string;
  size?: "small" | "default";
}

export const CheckboxSegmented = ({ label, className, size = "default", ...props }: CheckboxSegmentedProps) => (
  <div className={`checkbox-segmented-container ${className ?? ""} ${size === "small" ? "small" : ""}`}>
    <Checkbox {...props}>{label}</Checkbox>
  </div>
);
